var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.08,
    d: "M0 0H1440V1024H0z",
    transform: "translate(-652.000000, -320.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M209 116L1232 116 1232 909 209 909z",
    transform: "translate(-652.000000, -320.000000) translate(720.500000, 512.500000) rotate(-270.000000) translate(-720.500000, -512.500000)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1565C0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17 2.667h-.833V1H14.5v1.667H6.167V1H4.5v1.667h-.833C2.75 2.667 2 3.417 2 4.333v13.334c0 .916.75 1.666 1.667 1.666H17c.917 0 1.667-.75 1.667-1.666V4.333c0-.916-.75-1.666-1.667-1.666zm0 15H3.667V8.5H17v9.167zm0-10.834H3.667v-2.5H17v2.5z",
    transform: "translate(-652.000000, -320.000000) translate(652.000000, 320.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1208c2afa14224445b9dd54fade1f7f3.svg";
export { ForwardRef as ReactComponent };